var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69541 17C8.07841 17 7.76841 17.81 8.20241 18.287L11.2874 21.677C11.6804 22.108 12.3204 22.108 12.7134 21.677L15.7984 18.287C16.2324 17.81 15.9214 17 15.3054 17H8.69541Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19C14 19 14 14.697 14 14C14 12.895 13.105 12 12 12C10.895 12 10 12.895 10 14C10 14.697 10 19 10 19H14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1875 10.255H15.7305C15.7335 12.324 17.4015 14 19.4605 14C21.5165 14 23.1855 12.324 23.1875 10.255Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2695 10.255H0.8125C0.8145 12.323 2.4825 14 4.5415 14C6.5985 13.999 8.2675 12.324 8.2695 10.255Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1886 10.254C23.1886 12.325 15.7286 12.325 15.7286 10.254V8.927H8.26859V10.254C8.26859 12.325 0.808594 12.325 0.808594 10.254C0.808594 8.927 1.49859 7.77 2.52859 7.107C3.84859 6.081 7.14859 4 11.9986 4C16.8386 4 20.1386 6.081 21.4686 7.107C22.4986 7.771 23.1886 8.927 23.1886 10.254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.882884bdc7c78b526bac6ab98d6a0ec4.svg";
export { ForwardRef as ReactComponent };